import maintenanceTypes from '@/store/dict/maintenance'
import { operateMaxShowLength } from '@/store/dict/config'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'

export default function () {
  const searchBoxColumns = [
    {
      type: 'select',
      label: '项目名称(ID)',
      key: 'itemId',
      source: [],
      sourceKey: { label: 'name', value: 'id' },
      options: {
        clearable: true,
        filterable: true,
        remote: true,
        remoteMthod: this.getProjectNames,
      },
    },
    {
      type: 'select',
      label: '项目类型',
      key: 'itemType',
      source: maintenanceTypes.projectTypesSource,
      options: {
        clearable: true,
        filterable: true,
      },
    },
    {
      type: 'select',
      label: '维保类型',
      key: 'maintenanceType',
      source: [
        { label: '保养', value: 0 },
        { label: '维修', value: 1 },
      ],
      options: {
        clearable: true,
        filterable: true,
      },
    },
    {
      type: 'select',
      label: '状态',
      key: 'state',
      source: [
        { label: '无效', value: 0 },
        { label: '有效', value: 1 },
      ],
      options: {
        clearable: true,
        filterable: true,
      },
    },
    {
      type: 'input',
      label: '合作关系ID',
      key: 'collaborationId',
      options: {
        clearable: true,
        filterable: true,
      },
    },
    {
      type: 'select',
      label: '合作服务商名称(ID)',
      key: 'serviceId',
      source: [],
      sourceKey: { label: 'name', value: 'id' },
      options: {
        clearable: true,
        filterable: true,
        remote: true,
        remoteMthod: this.getCompanyProviderName,
      },
    },
    {
      type: 'select',
      label: '租赁方案名称(ID)',
      key: 'rentPlanId',
      source: [],
      sourceKey: { label: 'name', value: 'id' },
      options: {
        clearable: true,
        filterable: true,
        remote: true,
        remoteMthod: this.getRentPlanNames,
      },
    },
    {
      type: 'select',
      label: '租赁方案类型',
      key: 'rentPlanType',
      source: [
        { label: '个人', value: 1 },
        { label: '企业', value: 2 },
      ],
      options: {
        clearable: true,
        filterable: true,
      },
    },
    {
      type: 'input',
      label: '租赁订单ID',
      key: 'orderId',
      options: {
        clearable: true,
        filterable: true,
      },
    },
    {
      type: 'select',
      label: '司机名称(ID)',
      key: 'driverId',
      source: [],
      sourceKey: { label: 'customerName', value: 'id' },
      options: {
        clearable: true,
        filterable: true,
        remote: true,
        remoteMthod: this.getDriversName,
        jsxRender: (option) => {
          return <CustomerNameOptionItem data={option} />
        },
      },
    },
    {
      type: 'select',
      label: '车辆品牌',
      key: 'brandId',
      source: [],
      sourceKey: { label: 'brand', value: 'id' },
      options: {
        clearable: true,
        filterable: true,
        change_s: this.handleBrandIdChange,
      },
    },
    {
      type: 'select',
      label: '车系',
      key: 'carSeriesId',
      source: [],
      sourceKey: { label: 'series', value: 'seriesId' },
      options: {
        disabled: true,
        clearable: true,
        filterable: true,
        remote: true,
      },
    },
    {
      type: 'input',
      label: '车辆ID',
      key: 'carId',
      options: {
        clearable: true,
        filterable: true,
      },
    },
    {
      type: 'select',
      label: '车牌号',
      key: 'carIdForPlateNo',
      source: [],
      sourceKey: { label: 'name', value: 'id' },
      options: {
        clearable: true,
        filterable: true,
        remote: true,
        remoteMthod: this.getPlateNo,
      },
    },
    {
      type: 'select',
      label: 'VIN',
      key: 'carIdForVin',
      source: [],
      sourceKey: { label: 'name', value: 'id' },
      options: {
        clearable: true,
        filterable: true,
        remote: true,
        remoteMthod: this.getCarLicenseManageLikeByVin,
      },
    },
  ]

  const tableColumns = [
    {
      name: 'driverIdAndName',
      align: 'center',
      columnProps: {
        label: '司机名称(ID)',
        prop: 'driverIdAndName',
        minWidth: 120,
      },
      render: ({ row }) => {
        const { driverId, driverName } = row
        return (
          <span class="a-hover-link" onClick={() => this.openDriverListPage({ id: driverId, customerType: 1 })}>
            {driverName}({driverId})
          </span>
        )
      },
    },
    {
      name: 'carName',
      align: 'center',
      columnProps: {
        label: '车辆名称',
        prop: 'carName',
        minWidth: 120,
      },
      render: ({ row }) => {
        return (
          <span class="a-hover-link" onClick={() => this.openCarListPage({ id: row.carId })}>
            {row.carName}
          </span>
        )
      },
    },
    {
      name: 'plateNo',
      align: 'center',
      columnProps: {
        label: '车牌号',
        prop: 'plateNo',
        minWidth: 100,
      },
      render: ({ row }) => {
        return (
          <span class="a-hover-link" onClick={() => this.openCarListPage({ id: row.carId })}>
            {row.plateNo}
          </span>
        )
      },
    },
    {
      name: 'vin',
      align: 'center',
      columnProps: {
        label: 'VIN',
        prop: 'vin',
        minWidth: 200,
      },
      render: ({ row }) => {
        return (
          <span class="a-hover-link" onClick={() => this.openCarListPage({ vin: row.vin })}>
            {row.vin}
          </span>
        )
      },
    },
    {
      name: 'rentPlanNameAndId',
      align: 'center',
      columnProps: {
        label: '租赁方案名称(ID)',
        prop: 'rentPlanNameAndId',
        minWidth: 200,
      },
      render: ({ row }) => {
        if (!row.rentPlanNameAndId) {
          return '--'
        }
        return (
          <span class="a-hover-link" onClick={() => this.openRentPlanPage(row)}>
            {row.rentPlanNameAndId}
          </span>
        )
      },
    },
    {
      name: 'rentPlanTypeName',
      align: 'center',
      columnProps: {
        label: '租赁方案类型',
        prop: 'rentPlanTypeName',
        minWidth: 120,
      },
    },
    {
      name: 'collaborationId',
      align: 'center',
      columnProps: {
        label: '合作关系ID',
        prop: 'collaborationId',
        minWidth: 120,
      },
      render: ({ row }) => {
        if (!row.collaborationId) {
          return '--'
        }
        return (
          <span class="a-hover-link" onClick={() => this.openCollaborationPage(row)}>
            {row.collaborationId}
          </span>
        )
      },
    },
    {
      name: 'serviceId',
      align: 'center',
      columnProps: {
        label: '合作服务商ID',
        prop: 'serviceId',
        minWidth: 120,
      },
      render: ({ row }) => {
        if (!row.serviceId) {
          return '--'
        }

        return (
          <span class="a-hover-link" onClick={() => this.openservicePage(row)}>
            {row.serviceId}
          </span>
        )
      },
    },
    {
      name: 'serviceName',
      align: 'center',
      columnProps: {
        label: '合作服务商名称',
        prop: 'serviceName',
        minWidth: 120,
      },
    },
    {
      name: 'itemId',
      align: 'center',
      columnProps: {
        label: '项目ID',
        prop: 'itemId',
        minWidth: 120,
      },
      render: ({ row }) => {
        if (!row.itemId) {
          return '--'
        }
        return (
          <span class="a-hover-link" onClick={() => this.openProjectPage(row)}>
            {row.itemId}
          </span>
        )
      },
    },
    {
      name: 'itemName',
      align: 'center',
      columnProps: {
        label: '项目名称',
        prop: 'itemName',
        minWidth: 120,
      },
    },
    {
      name: 'itemTypeName',
      align: 'center',
      columnProps: {
        label: '项目类型',
        prop: 'itemTypeName',
        minWidth: 120,
      },
    },
    {
      name: 'maintenanceTypeName',
      align: 'center',
      columnProps: {
        label: '维保类型',
        prop: 'maintenanceTypeName',
        minWidth: 120,
      },
    },
    {
      name: 'itemPrice',
      align: 'center',
      columnProps: {
        label: '方案价格(元)',
        prop: 'itemPrice',
        minWidth: 120,
      },
    },
    {
      name: 'agreePrice',
      align: 'center',
      columnProps: {
        label: '协议价格(元)',
        prop: 'agreePrice',
        minWidth: 120,
      },
    },
    {
      name: 'usableStoreNameList',
      align: 'center',
      columnProps: {
        label: '适用维修厂',
        prop: 'usableStoreNameList',
        minWidth: 120,
      },
    },
    {
      name: 'usableCityList',
      align: 'center',
      columnProps: {
        label: '适用城市',
        prop: 'usableCityList',
        minWidth: 120,
      },
    },
    {
      name: 'stateName',
      align: 'center',
      columnProps: {
        label: '状态',
        prop: 'stateName',
        minWidth: 120,
      },
    },
    {
      name: 'mainInfoStateName',
      align: 'center',
      columnProps: {
        label: '维保项目状态',
        prop: 'mainInfoStateName',
        minWidth: 120,
      },
    },
    {
      name: 'mainInfoFailReason',
      align: 'center',
      columnProps: {
        label: '失败原因',
        prop: 'mainInfoFailReason',
        minWidth: 120,
      },
    },
  ]

  this.$nextTick(() => {
    tableColumns.push({
      name: 'operate',
      align: 'center',
      columnProps: {
        label: '操作',
        width: 240,
        fixed: 'right',
      },
      maxShowLength: operateMaxShowLength,
      render: ({ row }) => {
        const btns = []
        btns.push(
          this.$createElement(
            'el-button',
            {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.SearchOrder(row)
                },
              },
            },
            '查看订单信息',
          ),
        )
        if (row.mainInfoState === -1) {
          btns.push(
            this.$createElement(
              'el-button',
              {
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    this.recreateCreateOrder(row)
                  },
                },
              },
              '重新创建维保订单',
            ),
          )
        }

        return btns
      },
    })
  })
  return {
    searchBoxColumns,
    tableColumns,
  }
}
